import { render, staticRenderFns } from "./OpenClose.vue?vue&type=template&id=2597a893&scoped=true&"
import script from "./OpenClose.vue?vue&type=script&lang=js&"
export * from "./OpenClose.vue?vue&type=script&lang=js&"
import style0 from "./OpenClose.vue?vue&type=style&index=0&id=2597a893&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597a893",
  null
  
)

export default component.exports